﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type SetErrorMessage = { type: "setErrorMessage"; message: string };
type Navigate = {
    type: "navigate";
    uri: string;
    replace?: boolean;
    forceLoad?: boolean;
};
type SetField = {
    type: "setField";
    field: "uiCulture";
    markAsChanged: boolean;
    value: string;
};

type SettingsSubPageViewAction = SetErrorMessage | Navigate | SetField;

interface CustomerSettingsPageViewState {
    uiCulture: string;
    errorMessage?: string;
    loading?: boolean;
    hasLoadedTextCodes?: boolean;
    navigateUri?: string;
    navigateReplace?: boolean;
    navigateForceLoad?: boolean;
    hasEditedForm: boolean;
}

export type SessionState = "New" | "Ongoing" | "Completed";

export function reducer(
    state: CustomerSettingsPageViewState,
    action: SettingsSubPageViewAction
): CustomerSettingsPageViewState {
    switch (action.type) {
        case "setErrorMessage": {
            return {
                ...state,
                errorMessage: action.message,
            };
        }
        case "navigate": {
            return {
                ...state,
                errorMessage: null,
                loading: action.uri ? true : false,
                navigateUri: action.uri,
                navigateReplace: action.replace,
                navigateForceLoad: action.forceLoad,
            };
        }
        case "setField": {
            return {
                ...state,
                hasEditedForm: action.markAsChanged,
                [action.field]: action.value,
            };
        }
    }
}
